import { Component, OnInit, Input } from '@angular/core';
import { HelpIntroduction, Guide } from '@model';
import { SxDialogService } from '@services';
import { GuideComponent } from '@core/components/guide/guide.component';
import { Store } from '@ngrx/store';
import * as fromHelpStore from '@appStore/help';

@Component({
    selector: 'app-help-introduction',
    templateUrl: './help-introduction.component.html',
    standalone: false
})
export class HelpIntroductionComponent implements OnInit {
  @Input()
  introductionData: HelpIntroduction;
  @Input()
  guides: Guide[];

  constructor(private sxDialogService: SxDialogService, private helpStore: Store<fromHelpStore.State>) {}

  ngOnInit() {}

  openGuide(guide: Guide) {
    if (!guide.isRead && guide.isStandardGuide) {
      this.helpStore.dispatch(new fromHelpStore.GuideSetAsRead(guide.id));
    }

    this.sxDialogService.openDialog(GuideComponent, guide, { disableClose: true });
  }
}
